const FREEWHEEL_DEFAULTS = {
    fwVideoIDPrefix: 'as-', // prepended to the videoAssetID for all videos

    // Adult Swim Prod config values
    networkID: 48804,
    serverURL: 'https://bea4.v.fwmrm.net/ad/g/1',
    profileID: '48804:turner_html5_pem',

    videoAssetID: 'DemoVideoGroup.01',
    siteSectionID: false,  // pass in to ads config to always set this siteSectionID as this value no matter the platform
    siteSectionUnauthIDPrefix : 'as.com-unauthenticated',  // if siteSectionID is not set, this + the plaform is used to set siteSectionID
    siteSectionAuthIDPrefix : 'as.com-authenticated',

    preroll: true,  // set to false to never show preroll even if ads are enabled and it wants to serve one
    midroll: true,  // set to false to never show midroll even if ads are enabled and it wants to serve one
    postroll: true,  // set to false to never show postroll even if ads are enabled and it wants to serve one

    debug: false
};


// Adult Swim Dev config values
// "networkID": 42448,
// "serverURL": "http://bea4.adultswim.com/ad/g/1",
// "profile": "42448:turner_jsam_live",
// "siteSectionID": 'as.com-unauthenticated-' + (deviceProfile.isMobile() ? (deviceProfile.isIOS() ? 'ios' : (deviceProfile.isAndroid() ? 'android' : 'other')) : 'desktop'),


// Freewheel Demo config values
// networkID: 96749,
// serverURL: 'http://demo.v.fwmrm.net/ad/g/1',
// profileID: 'global-js',
// videoAssetID: 'DemoVideoGroup.01',
// siteSectionID : 'DemoSiteGroup.01',

export default FREEWHEEL_DEFAULTS;


// WEBPACK FOOTER //
// ./src/ads/FreewheelDefaults.js